/**
 * Transformer that is triggered when the user is on `building-info` page and
 * fills the form. After they complete each field a new one shows up and for
 * greater user experience this transformer scrolls to this new field right after the user
 * completes a previous one.
 */
export default (kasko) => {
  kasko.addEventListener('form-changed', ({ current, previous }) => {
    const state = kasko.getState();

    if (state.route.state.url !== '/building-info') {
      return;
    }

    if (
      current &&
      previous &&
      ((current.house_type && !previous.house_type) ||
        (current.rooms && !previous.rooms) ||
        (current.massive_design_type && !previous.massive_design_type) ||
        (current.massive_design_type &&
          (previous.massive_design_type === null || previous.massive_design_type === undefined)) ||
        (current.interior && !previous.interior) ||
        (current.risk_address_street &&
          current.risk_address_house_number &&
          current.risk_address_postcode &&
          !previous.risk_address_street) ||
        (current.risk_address_city &&
          current.risk_address_house_number &&
          current.risk_address_street &&
          !previous.risk_address_city) ||
        (current.risk_address_house_number &&
          current.risk_address_street &&
          current.risk_address_postcode &&
          !previous.risk_address_house_number))
    ) {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 100);
    }
  });
};
